import React from 'react';
import { useResetRecoilState } from 'recoil';
import { IBlock } from '../../../../utils/types/contentful';
import { collectionSearchActiveState } from '../../../../utils/recoil/collection';
import { Button } from '../../../UI/Elements';
import { SubCategoryHeader } from 'components/Ecommerce/Shop';
import { formatContentfulComponentProps } from 'utils/globals';
import CollectionBreadcrumb from 'components/UI/Navigation/Breadcrumbs/CollectionBreadcrumb';
import { Divider } from 'components/UI/Elements/Divider';
import { Label } from 'components/UI/Elements/Label/label';
import { Icon } from '@nooz-optics/nooz-components-lib';
import clsx from 'clsx';
import { drawerState, useDrawer } from 'utils/recoil/drawer';

export interface CategoriesShopNavProps {
  categories: IBlock;
  subCategories: IBlock;
  subCategory: IBlock;
  category: IBlock;
  filterLabel: IBlock;
  filters: IBlock;
  link: IBlock;
  header: IBlock;
  FiltersBody: any;
}

export const FilterButton = ({ className, onClick, filters, filterLabel }) =>
  filters && filterLabel ? (
    <div className={clsx(className)} onClick={onClick}>
      <div className={'flex w-max cursor-pointer items-center space-x-2'}>
        <Label {...filterLabel} icon={undefined} />
        <Icon {...filterLabel?.icon} />
      </div>
    </div>
  ) : null;

export const CategoriesShopNav = ({
  subCategories,
  filters,
  category,
  filterLabel,
  link,
  header,
  FiltersBody,
}: CategoriesShopNavProps) => {
  const resetDrawer = useResetRecoilState(drawerState);
  const resetIsFilterActive = useResetRecoilState(collectionSearchActiveState);
  const drawer = useDrawer();

  const onClick = () => {
    resetIsFilterActive();
    resetDrawer();
  };

  const onFilterClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    drawer.open({
      title: filterLabel,
      placement: 'right',
      body: FiltersBody,
      footer: null,
      backdropLink: null,
      width: 'w-screen-95 sm:w-screen/2 md:w-screen/3',
    });
  };

  return (
    <>
      {header ? (
        <div className='hidden md:flex mt-4 px-4 py-2 items-center justify-between  main-wrapper'>
          <SubCategoryHeader
            {...formatContentfulComponentProps(header)}
            filters={filters}
            filterLabel={filterLabel}
            onFilterClick={onFilterClick}
          />
        </div>
      ) : null}
      <div className={'hidden md:block w-full my-4 px-4 lg:px-16 xl:px-32 '}>
        <Divider color={'gray-500'} />
      </div>
      <div className='w-screen bg-gray-100 sticky pt-4 top-16 z-50 flex flex-col align-end'>
        <div className='relative flex flex-row px-4 mb-4 lg:px-16 xl:px-32'>
          <span className='absolute md:hidden z-1 right-0 bg-gradient-to-l from-gray-100 via-gray-100 w-16 h-full'></span>
          {subCategories ? (
            <div className='flex flex-1 overflow-scroll no-scrollbar'>
              <CollectionBreadcrumb
                onClick={onClick}
                category={category}
                activeLink={link}
                subCategories={subCategories}
              />
            </div>
          ) : null}
          <div className={'hidden md:block'}>
            {filters && filterLabel ? (
              <Button type={'white'} color={{ classname: 'black' }}>
                <FilterButton
                  {...{
                    className: 'flex items-center',
                    onClick: onFilterClick,
                  }}
                  filters={filters}
                  filterLabel={filterLabel}
                />
              </Button>
            ) : null}
          </div>
        </div>

        <div className={'md:hidden w-full px-4 lg:px-16 xl:px-32 '}>
          <Divider color={'gray-500'} />
        </div>
      </div>
      {header ? (
        <div className='md:hidden flex pt-4 px-4 items-center justify-between w-full'>
          <SubCategoryHeader
            {...formatContentfulComponentProps(header)}
            filters={filters}
            filterLabel={filterLabel}
            onFilterClick={onFilterClick}
          />
        </div>
      ) : null}
    </>
  );
};
